<nav class="d-flex container-fluid" style="background-color: var(--striped-bg)">
    <button
        type="button"
        class="btn btn-text-primary"
        style="padding: 0 1.5rem 0 0"
        (click)="navigateToParent()">
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.89054 8.61144C2.59291 8.31382 2.59291 7.83047 2.89054 7.53284L6.70028 3.72322C6.99792 3.42559 7.48128 3.42559 7.77891 3.72322C8.07655 4.02085 8.07655 4.50419 7.77891 4.80182L5.26687 7.31141H12.572C12.9935 7.31141 13.334 7.65189 13.334 8.07333C13.334 8.49477 12.9935 8.83526 12.572 8.83526H5.26925L7.77653 11.3448C8.07417 11.6425 8.07417 12.1258 7.77653 12.4234C7.4789 12.7211 6.99554 12.7211 6.6979 12.4234L2.88816 8.61382L2.89054 8.61144Z" />
        </svg>
    </button>
    <ol class="breadcrumb my-3">
        @for (breadcrumb of breadcrumbs$ | async; track breadcrumb; let last = $last) {
            @switch (last) {
                @case (false) {
                    <li class="breadcrumb-item">
                        <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
                    </li>
                }
                @case (true) {
                    <li class="breadcrumb-item active">{{ breadcrumb.label }}</li>
                }
            }
        }
    </ol>
</nav>
